'use strict';

(function () {
  var API_URL = 'https://api.giveaway.ninja/api/ui/calculateEntries';
  var TOKEN_KEY = 'giveawayninja_at';
  var TOKEN_MAX_WAIT = 5000;
  var TOKEN_POLL_INTERVAL = 200;
  var FETCH_TIMEOUT = 10000;
  var DEBOUNCE_DELAY = 400;

  var accessTokenPromise = null;
  var accessToken = null;

  function getAccessToken() {
    if (accessTokenPromise) return accessTokenPromise;
    accessTokenPromise = new Promise(function (resolve) {
      var startTime = Date.now();
      function poll() {
        try {
          var token = localStorage.getItem(TOKEN_KEY);
          if (token && token !== 'null') { resolve(token); return; }
          if (Date.now() - startTime >= TOKEN_MAX_WAIT) { resolve(null); return; }
          setTimeout(poll, TOKEN_POLL_INTERVAL);
        } catch (e) { resolve(null); }
      }
      poll();
    });
    return accessTokenPromise;
  }

  class GiveawayCartItemEntry extends HTMLElement {
    connectedCallback() {
      this.abortController = null;
      this.debounceTimerId = null;
      this.disconnected = false;
      this.badge = this.querySelector('.giveaway-cart-item-entry__badge');
      if (!this.badge) return;

      this.init();
    }

    disconnectedCallback() {
      this.disconnected = true;
      if (this.abortController) this.abortController.abort();
      clearTimeout(this.debounceTimerId);
      if (this.quantityInput && this.boundOnQuantityChange) {
        this.quantityInput.removeEventListener('change', this.boundOnQuantityChange);
      }
    }

    async init() {
      if (!accessToken) {
        accessToken = await getAccessToken();
      }
      if (!accessToken || this.disconnected) return;

      this.calculate();
      this.bindQuantityChange();
    }

    bindQuantityChange() {
      var itemIndex = this.dataset.itemIndex;
      if (!itemIndex) return;

      var quantityInput = document.getElementById('Quantity-' + itemIndex);
      if (quantityInput) {
        this.quantityInput = quantityInput;
        this.boundOnQuantityChange = this.onQuantityChange.bind(this);
        quantityInput.addEventListener('change', this.boundOnQuantityChange);
      }
    }

    onQuantityChange() {
      var self = this;
      clearTimeout(this.debounceTimerId);
      this.debounceTimerId = setTimeout(function () {
        if (!self.disconnected && self.quantityInput) {
          var val = parseInt(self.quantityInput.value, 10);
          if (!isNaN(val) && val > 0) {
            self.dataset.quantity = val;
            self.calculate();
          }
        }
      }, DEBOUNCE_DELAY);
    }

    async calculate() {
      if (this.disconnected || !accessToken) return;

      var giveawayId = this.dataset.giveawayId;
      var productId = this.dataset.productId;
      var variantId = this.dataset.variantId;
      var price = parseInt(this.dataset.variantPrice, 10) || 0;
      var quantity = parseInt(this.dataset.quantity, 10) || 1;

      if (!giveawayId || !productId || !variantId) return;

      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();
      var timeoutId = setTimeout(
        function () { this.abortController.abort(); }.bind(this),
        FETCH_TIMEOUT
      );

      try {
        // NOTE: Access token passed as query param per Giveaway Ninja API requirements.
        // Prefer Authorization header if their API adds support for it.
        var response = await fetch(
          API_URL + '?access_token=' + encodeURIComponent(accessToken),
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              giveawayId: giveawayId,
              productId: String(productId),
              variantId: String(variantId),
              quantity: quantity,
              price: price,
            }),
            signal: this.abortController.signal,
          }
        );
        clearTimeout(timeoutId);

        if (this.disconnected || !response.ok) return;

        var result = await response.json();
        if (this.disconnected) return;

        if (result.status === 'Success' && result.data) {
          this.updateBadge(result.data);
        }
      } catch (error) {
        clearTimeout(timeoutId);
        if (!this.disconnected) {
          this.abortController = new AbortController();
        }
      }
    }

    updateBadge(data) {
      if (!this.badge) return;
      var totalEntries = data.totalEntries || 0;
      if (totalEntries <= 0 || data.isExpired) {
        this.badge.style.display = 'none';
        this.classList.remove('is-visible');
        return;
      }
      var textEl = this.badge.querySelector('.giveaway-cart-item-entry__text');
      if (textEl) {
        var label = this.badge.dataset.entriesLabel || '{entries} entries';
        textEl.textContent = label.replace('{entries}', totalEntries);
      }
      this.badge.style.display = '';
      this.classList.add('is-visible');
    }
  }

  if (!customElements.get('giveaway-cart-item-entry')) {
    customElements.define('giveaway-cart-item-entry', GiveawayCartItemEntry);
  }
})();
